import React, { PureComponent } from 'react';

class AjusteCargoRdButton extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { ajusteCargoRdButton, selectRadioIngresoAjustes, permisos, form } = this.props;
        let permisoDeAlta = permisos && permisos.Alta ? false : true;
        return (
            <div className="row top-separator-xs">
               
                <div className="col-xs-6">
                    <label className="label-primary">Tipo de movimiento *</label>
                    <div className="row">
                        <div className="col-xs-3 padding-rd-button">

                            <div className="container-radio radio-margin" >
                                <div className="row">
                                    <div className="col-xs-12">                        
                                        <input id={"ajuste"} type="radio" disabled={permisoDeAlta} name="ajuste" onChange={(e) => selectRadioIngresoAjustes("ajusteCargoRdButton",0,form.resetFields)} value={0} checked={ajusteCargoRdButton == 0} />
                                        <label className="lbl-radio label-secondary" htmlFor={"ajuste"}>Ajuste</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div className="container-radio radio-margin" >
                                <div className="row">
                                    <div className="col-xs-12">
                                        <input id={"cargo"} type="radio" name="cargo" disabled={permisoDeAlta} onChange={(e) => selectRadioIngresoAjustes("ajusteCargoRdButton",1,form.resetFields)} value={1} checked={ajusteCargoRdButton == 1} />
                                        <label className="lbl-radio label-secondary" htmlFor={"cargo"}>Cargo</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default AjusteCargoRdButton;